<template>
  <div>
    <b-loading :active.sync="loadingInicial" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title
        :text="tipo_atividade ? tipo_atividade.nome : 'Carregando Planilha...'"
      />
    </div>
    <div class="w-full flex justify-end items-center gap-2 pb-5">
      <div class="flex justify-end">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="border-radius: 25px"
              color="#031127"
              dark
              v-bind="attrs"
              v-on="on"
            >
              Opções upload
            </v-btn>
          </template>
          <div class="flex flex-col mt-2 p-1">
            <v-btn
              color="#031127"
              dark
              @click.native="upload('arquivos-atividade.upload')"
            >
              Upload
            </v-btn>
            <v-btn
              class="mt-2"
              color="#031127"
              dark
              @click.native="upload('arquivos-atividade.nao-processadas')"
            >
              Upload não processados
            </v-btn>
            <v-btn
              v-if="hasRole('super-admin')"
              color="#031127"
              dark
              @click.native="AtualizarDadosPlanilha()"
              class="mt-2"
              >Carregar dados
            </v-btn>
            <v-btn
              color="#031127"
              dark
              @click.native="handleEmpresaAusentesModel()"
              class="mt-2"
              >Adicionar Empresa Ausentes
            </v-btn>
          </div>
        </v-menu>
      </div>

      <v-btn
        color="#031127"
        dark
        style="border-radius: 25px"
        @click.native="exportPlanilha('exportArquivoAtividade')"
      >
        Export
        {{ tipo_atividade ? tipo_atividade.nome : "Carregando Planilha..." }}
      </v-btn>

      <v-btn
        v-if="!competencia.gerado"
        color="#031127"
        style="border-radius: 25px"
        dark
        @click.native="carregarPlanilha()"
        class="mr-1"
        >Carregar planilha
      </v-btn>
      <v-btn
        color="#031127"
        style="border-radius: 25px"
        dark
        @click.native="listar_dctfweb()"
        >Atualizar planilha
      </v-btn>
    </div>

    <div class="w-full flex justify-start gap-4 items-center mb-2">
      <label class="w-1/5">
        <Lynx-Label label="Carteiras" class=" " />

        <treeselect
          :multiple="true"
          :options="lista_carteiras"
          placeholder="Selecione a(s) cidades(s)"
          v-model="filtros.carteira_filter"
        />
      </label>
      <label class="w-1/4">
        <Lynx-Label label="Regime triburario" class=" " />
        <b-select
          placeholder="Todos"
          name="form-class"
          v-model="filtros.regime_tributario"
        >
          <!-- <option selected disabled>Selecione as carteiras...</option> -->

          <option :value="null">Todos</option>
          <option
            v-for="item in lista_regime_tributario"
            :key="item.id"
            :value="item.label"
          >
            {{ item.label }}
          </option>
        </b-select>
      </label>
      <label class="w-1/4">
        <Lynx-Label label="Opções" class=" " />
        <b-select
          placeholder="Todos"
          name="form-class"
          v-model="filtros.opcoes"
        >
          <option :value="null">Todos</option>
          <option v-for="item in lista_opcoes" :key="item.id" :value="item.id">
            {{ item.label }}
          </option>
        </b-select>
      </label>
      <label class="w-1/4">
        <Lynx-Label label="Conferido" class=" " />
        <b-select
          placeholder="Todos"
          name="form-class"
          v-model="filtros.conferido"
        >
          <option
            v-for="item in [
              { id: null, label: 'Todos' },
              { id: 1, label: 'Concluido' },
              { id: 0, label: 'Desmarcado' },
              { id: 2, label: 'Não Concluido' },
            ]"
            :key="item.id"
            :value="item.id"
          >
            {{ item.label }}
          </option>
        </b-select>
      </label>
    </div>
    <div class="w-full flex justify-start gap-2 items-center mb-2">
      <label class="w-1/5">
        <Lynx-Label label="ID Empresas" class=" " />

        <Lynx-Input v-model="empresas_id" />
      </label>
      <!-- <label class="w-1/4">
        <Lynx-Label label="Cidades" class=" " />

        <v-autocomplete
          v-model="filtros.cidades"
          :items="lista_cidades"
          :search-input.sync="searchQuery"
          item-text="nome"
          item-value="nome"
          label="Selecione a(s) cidades(s)"
          multiple
          dense
          @change="clearSearchQuery"
        />
      </label> -->
      <label class="w-1/5">
        <Lynx-Label label="Status" class=" " />

        <treeselect
          :multiple="true"
          :options="[
            { id: 'pendente', label: 'Pendente' },
            { id: 'finalizado', label: 'Finalizado' },
          ]"
          placeholder="Selecione os status"
          v-model="filtros.status"
        />
      </label>

      <label
        v-if="colunas.some((coluna) => coluna.field === 'data')"
        class="w-1/5"
      >
        <Lynx-Label label="Seleciona um período" />
        <b-datepicker
          v-model="filtros.data"
          placeholder="Seleciona um período"
          :date-parser="(date) => new Date(date)"
          :month-names="monthNames"
          :day-names="dayNames"
          :years-range="[-5, 5]"
          range
        >
          <b-button
            label="Clear"
            type="is-danger"
            icon-left="close"
            outlined
            @click="filtros.data = null"
          />
        </b-datepicker>
      </label>

      <label class="">
        <Lynx-Label label="Por paginas" class=" " />

        <b-select v-model="filtros.perPage">
          <option
            :value="perPageOption"
            v-for="perPageOption in perPageOptions"
            :key="perPageOption"
          >
            {{ perPageOption }}
          </option>
        </b-select>
      </label>

      <!-- <label class="w-1/6">
      <Lynx-Label label="Faturamento" class=" " />
      <Lynx-Input v-model="faturamento"/>
    </label> -->
    </div>

    <div class="flex justify-end">
      <v-btn color="#051b3e" small @click="atualizarPlaniha()">
        <v-icon color="#fff">mdi-content-save</v-icon>
      </v-btn>
    </div>
    <div class="table-container" v-if="pagination.total > 0">
      <b-table
        :loading="loading"
        backend-pagination
        @page-change="onPageChange"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        :total="pagination.total"
        :current-page="pagination.current_page"
        :per-page="pagination.per_page"
        :columns="colunas"
        :data="loading ? [] : lista_dctfweb"
        paginated
        striped
        style="font-size: 12px"
        :style="tamanhoTela"
        detailed
      >
        <template slot-scope="props" v-if="props.row['id'] != null">
          <b-table-column
            :style="getColStyle(column.field)"
            v-for="column in colunas"
            :key="column.field"
            :field="column.field"
            style="height: 20px"
          >
            <template
              v-if="
                [
                  'empresa_id',
                  'cnpj',
                  'razao_social',
                  'carteiras',
                  'cidade',
                  'regime_tributario',
                ].includes(column.field)
              "
            >
              {{ props.row[column.field] }}
            </template>

            <template v-if="['inicio_atividades'].includes(column.field)">
              {{ formatEnToBr(props.row[column.field]) }}
            </template>

            <template v-if="['data'].includes(column.field)">
              <span v-if="tipo_atividade.integracao == null">
                {{ formatEnToBr(props.row[column.field]) }}
              </span>
              <span
                v-else-if="tipo_atividade.integracao == 'MotivoDesativacao'"
              >
                {{
                  props.row.empresa.motivo_desativacao != null
                    ? formatEnToBr(
                        props.row.empresa.motivo_desativacao.data_encerramento
                      )
                    : "Sem data"
                }}
              </span>

              <div v-else-if="tipo_atividade.integracao == 'EmiteNotaFiscal'">
                <v-chip v-if="props.row.prioridade_empresa" color="info" text-color="white">
                  {{ formatDateDay(props.row.prioridade_empresa.data) }}
                </v-chip>
                     <v-btn
                fab
                color="primary"
                small
                class="ml-1"
                v-if="props.row.prioridade_empresa"
                @click.native="showModalPrioridadeEmpresa(props.row, 'ver')"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>

                <Treeselect
                  v-else
                  :multiple="false"
                  :options="generateOptions()"
                  placeholder="Prioridade"
                  v-model="props.row.prioridade_empresa"
                  @input="showModalPrioridadeEmpresa(props.row, 'form', $event)"
                />
                
              </div>
            </template>
            <template v-if="column.field === 'emite_nf'">
              <v-chip :color="props.row[column.field] ? 'green' : 'red'" dark>
                {{ props.row[column.field] ? "Sim" : "Não" }}
              </v-chip>
         
            </template>

            <template v-if="column.field === 'responsavel'">
              <treeselect
                :multiple="false"
                :options="lista_usuarios"
                placeholder="Selecione Responsavel..."
                v-model="props.row.responsavel"
              />
            </template>

            <b-select
              v-if="column.field === 'opcoes'"
              style="font-size: 13px"
              placeholder="Selecione as opções"
              name="form-class"
              v-model="props.row['opcoes']"
            >
              <option
                v-show="
                  item.id != 5 ||
                  (item.id == 5 && props.row.arquivo_dctfweb.length == 0)
                "
                v-for="item in lista_opcoes"
                :key="item.id"
                :value="item.id"
              >
                {{ item.label }}
              </option>
            </b-select>

            <b-switch
              :disabled="validarCompetencia(props.row)"
              v-if="column.field === 'conferido'"
              v-model="props.row[column.field]"
              :true-value="1"
              :false-value="0"
            />

            <div
              v-if="column.field === 'status'"
              :class="`p-1 text-neutral-900 text-uppercase ${
                props.row.status === 'pendente'
                  ? 'bg-warning-base'
                  : 'bg-success-base'
              }`"
            >
              {{ props.row.status }}
            </div>

            <div
              v-if="
                column.field === 'arquivoDctfweb' &&
                props.row.arquivo_dctfweb != null
              "
            >
              <span
                class="py-1 px-2 bg-neutral-300 rounded mr-2 mb-2 text-xs"
                v-show="!arquivo.user_del"
                v-for="(arquivo, key) in props.row.arquivo_dctfweb"
                :key="key"
                v-text="arquivo.tipo ? arquivo.tipo : arquivo.tipo_atividade"
              >
              </span>
            </div>
            <div v-if="column.field === 'logs'">
              <div v-if="props.row.usuario">
                <b-tag type="is-success"> Atualizou: </b-tag>
                {{ props.row.usuario.nome_completo }}
              </div>

              <div v-if="props.row.arquivo_dctfweb[0]" class="mt-1">
                <b-tag type="is-success"> Up arquivo: </b-tag>
                {{ props.row.arquivo_dctfweb[0].in.nome_completo }}
              </div>
            </div>
          </b-table-column>
        </template>
        <template slot="detail" slot-scope="props">
          <GerenciamentoArquivoAtividadeDetails
            :current-arquivo-atividade="props.row"
            :tipo-atividade="tipo_atividade"
            @atualizar="atualizouPrioridade()"
          />
        </template>
        <template #empty>
          <div class="w-full flex justify-center">
            <Not-Found-Data text="Nenhum Tabela carregada!" />
          </div>
        </template>
        <b-pagination
          :total="pagination.total"
          :current.sync="current_page"
          :per-page="pagination.per_page"
        />
      </b-table>

      <div class="float-left" style="margin-top: -60px">
        <b-pagination
          :total="pagination.total"
          :current.sync="current_page"
          :per-page="pagination.per_page"
        />
      </div>
    </div>
    <div v-else class="flex justify-center mt-4">
      <NotFoundData
        :text="
          competencia.gerado
            ? 'Aguarde estamos montando a tabela'
            : 'Nenhum dado encontrado'
        "
      />
    </div>

    <b-modal :active.sync="empresaAusentesModel">
      <div class="bg-neutral-300 p-8" style="height: 300px">
        <Lynx-Title text="Empresas ausentes" />

        <v-autocomplete
          v-model="empresasAusentesSelecionadas"
          :items="empresasAusentes"
          :search-input.sync="searchQueryEmpresa"
          label="Selecione a(s) empresa(s)"
          multiple
          dense
          item-text="nome"
          item-value="id"
          :loading="loading"
          @change="clearSearchQuery"
        />

        <v-btn
          class="mt-2"
          color="#031127"
          dark
          :loading="loading"
          :disabled="!tipo_atividade"
          @click="adicionarEmpresas()"
          >Adicionar</v-btn
        >
      </div>
    </b-modal>
    <b-modal :active.sync="modalPrioridade.open">
      <v-card
        v-if="modalPrioridade.acao === 'form'"
        :loading="loading"
        elevation="10"
        class="p-3"
      >
        <Lynx-Title text="Prioridade Empresa" />
        <Lynx-Textarea
          placeholder="Digite o motivo para o envio"
          v-model="formPrioridade.motivo"
        />
        <div class="w-full flex justify-end items-start">
          <Lynx-Button
            :disabled="loading"
            size="small"
            @click.native="sendPrioridadeEmpresa"
            >Enviar</Lynx-Button
          >
        </div>
      </v-card>
      <div v-else>
        <EmpresaPioridadeCard
          v-if="linhaAtividadeEmpresa"
          :currentEmpresa="linhaAtividadeEmpresa"
          @atualizar="atualizouPrioridade()"
          @delete="deletePrioridadeEmpresa"
        />
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { monthNames, dayNames } from "@/utils/utils";
import { hasRole } from "@/utils/can";
import { mapGetters } from "vuex";
import GerenciamentoArquivoAtividadeDetails from "@/views/atividadesCompetencia/arquivosAtividade/GerenciamentoArquivoAtividadeDetails";
import { searchEmpresasRequest } from "@/services/requests/empresas";
import { showCidadesRequest } from "../../services/requests/estados";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { usersRequest } from "@/services/requests/users";
import LynxTextarea from "@/components/helpers/Textarea";
import { TipoDataObrigatoriedade } from "@/utils/enums/TipoDataObrigatoriedade";
import EmpresaPioridadeCard from "@/views/components/EmpresaPioridadeCard";
import moment from "moment";
import { formatEnToBr,formatDateDay } from "@/utils/momentHelpers";
export default {
  components: {
    NotFoundData,
    Treeselect,
    GerenciamentoArquivoAtividadeDetails,
    LynxTextarea,
    EmpresaPioridadeCard,
  },
  data() {
    return {
      monthNames,
      dayNames,
      form: [],
      selectedFiles: [],
      loading: false,
      loadingInicial: false,
      pasta_selected: null,
      isPressing: false,
      timer: null,
      preciona: 0,
      editavel: 0,
      logs: false,
      currentArquivosAtividade: {},
      arquivosAtividadeModal: false,
      empresaAusentesModel: false,
      empresasAusentes: null,
      empresasAusentesEstaoSelecionada: [],

      empresasAusentesSelecionadas: [],
      searchQuery: null,
      columns: [
        // {
        //   field: "id",
        //   label: "id",
        //   sortable: true,
        // },
        {
          field: "empresa_id",
          label: "Id",
          sortable: true,
        },

        {
          field: "cnpj",
          label: "cnpj",
        },
        {
          field: "razao_social",
          label: "razão social",
          sortable: true,
        },
        {
          field: "carteiras",
          label: "carteiras",
          sortable: true,
        },
        {
          field: "regime_tributario",
          label: "regime tributario",
        },
        {
          field: "opcoes",
          label: "opcoes",
          sortable: true,
        },
        {
          field: "arquivoDctfweb",
          label: "arquivo",
          sortable: true,
        },
        {
          field: "data",
          label: "data",
          sortable: true,
        },
        {
          field: "responsavel",
          label: "responsavel",
          sortable: true,
        },
        {
          field: "conferido",
          label: "DP",
          sortable: true,
        },
        {
          field: "status",
          label: "status",
          sortable: true,
        },
      ],

      lista_opcoes: [
        { id: 1, label: "Ok" },
        { id: 2, label: "Sem movimento" },
        { id: 3, label: "Sem procuração" },
        { id: 4, label: "Optante pelo simples nacional" },
        { id: 5, label: "Sem arquivo" },
        { id: 6, label: "Não optante SN" },
        { id: 7, label: "Enviado para Cliente" },
        { id: 8, label: "Enviado para Gestora" },
        { id: 9, label: "Outro Contador" },
        { id: 10, label: "Inativa" },
        { id: 11, label: "Competência no mês seguinte" },
        { id: 12, label: "Desobrigada" },
        { id: 13, label: "Debito Pendente" },
        { id: 14, label: "Omissão de Declaração" },
      ],
      searchQueryEmpresa: null,
      lista_usuarios: null,
      faturamento: 0,
      lista_regime_tributario: [
        { id: "Simples Nacional", label: "Simples Nacional" },
        { id: "Lucro Presumido", label: "Lucro Presumido" },
        { id: "Isento", label: "Isento" },
        {
          id: "Aguardando enquadramento no simples",
          label: "Aguardando enquadramento no simples",
        },
        { id: "presumido com equiparação", label: "presumido com equiparação" },
        {
          id: "Microempreendedor Individual (MEI)",
          label: "Microempreendedor Individual (MEI)",
        },
      ],

      dctfweb_fechamento: null,
      empresas_id: "",
      lista_cidades: null,
      filtros: {
        page: 1,
        empresas_id: null,
        status: null,
        carteira_filter: [],
        conferido: null,
        regime_tributario: null,
        opcoes: null,
        data: null,
        perPage: 10,
      },
      perPageOptions: [10, 50, 100],
      current_page: 1,
      lista_dctfweb_original: [],
      formPrioridade: {
        empresa_id: null,
        data: null,
        motivo: null,
        tipo: TipoDataObrigatoriedade.atividade,
      },
      modalPrioridade: { open: false, acao: null },
      linhaAtividadeEmpresa: null,
    };
  },
  watch: {
    "filtros.perPage"() {
      this.listar_dctfweb();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.listar_dctfweb();
    },
    faturamento() {
      if (this.faturamento < 1) {
        this.faturamento = 0;
      }
    },
    searchQueryEmpresa: _.debounce(function () {
      if (this.searchQueryEmpresa.length > 1) {
        this.searchEmpresa(this.searchQueryEmpresa);
      }
    }, 400),
    empresasAusentesSelecionadas() {
      console.log(this.empresasAusentes);
      this.empresasAusentesEstaoSelecionada = this.empresasAusentes.filter(
        (item) => this.empresasAusentesSelecionadas.includes(item.id)
      );
      console.log(this.empresasAusentesSelecionadas);
    },
    searchQuery: _.debounce(function () {
      if (this.searchQuery.length > 3) {
        this.searchCidades();
      }
    }, 400), // Adiciona um atraso de 300ms para evitar múltiplas chamadas durante a digitação
  },

  computed: {
    ...mapGetters(["getToken"]),
    tamanhoTela() {
      const tamanhoFixo = this.calcularTamanhoTabela();
      const larguraTela =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const tamanhoRelativo = (tamanhoFixo / larguraTela) * 100;
      const tamanhoFinal = tamanhoRelativo;
      return `width:${tamanhoFinal}vw;`;
    },
    lista_carteiras() {
      //  return this.$store.state.carteira.lista_carteiras;

      let carteira = Object.values(this.$store.state.carteira.lista_carteiras);
      let data = [];
      // data.push({ id: 'todas', label: 'todas',disabled:true });

      for (let i = 0; i < carteira.length; i++) {
        if (carteira[i].setor == "contabilidade") {
          data.push({ id: carteira[i].nome, label: carteira[i].nome });
        }
      }
      for (let i = 0; i < carteira.length; i++) {
        if (
          carteira[i].setor == "onboarding" &&
          carteira[i].nome != "Onboarding"
        ) {
          data.push({ id: carteira[i].nome, label: carteira[i].nome });
        }
      }
      return data;
    },
    dctfweb() {
      return this.$store.state.dctfweb.lista_dctfweb;
    },
    lista_dctfweb() {
      return this.dctfweb.data;
    },
    pagination() {
      return this.dctfweb.pagination;
    },
    tipo_atividade() {
      return this.dctfweb.tipo_atividade;
    },
    colunas() {
      let customColumns = this.dctfweb.colunas
        .filter((field) => field !== "user_up")
        .map((field) => ({
          field,
          label: field.replace("_", " "),
          sortable: true,
        }));
      if (this.tipo_atividade.arquivo) {
        customColumns.push({
          field: "arquivoDctfweb",
          label: "arquivo",
          sortable: true,
        });
      }

      customColumns.push({
        field: "logs",
        label: "Logs",
      });

      return customColumns;
    },

    competencia() {
      return {
        gerado: this.dctfweb.gerado,
        competencia: this.dctfweb.competencia,
      };
    },

    mensagem_alert() {
      return this.$store.state.dctfweb.mensagem_alert;
    },
  },
  created() {
    this.fetchCarteiras();
  },
  mounted() {
    this.listar_dctfweb_inicial();
  },
  filters: {
    money: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  methods: {
    formatEnToBr,
    formatDateDay,

    hasRole,
    async fetchCarteiras() {
      await this.$store.dispatch("carteira/listar_carteiras");
    },

    clearSearchQuery() {
      this.searchQueryEmpresa = "";
    },
    handleEmpresaAusentesModel() {
      this.empresaAusentesModel = !this.empresaAusentesModel;
    },
    searchCidades() {
      this.loading = true;

      showCidadesRequest(this.searchQuery)
        .then((res) => (this.lista_cidades = res.data))
        .finally(() => (this.loading = false));
    },
    enterCompetencia() {
      this.$router.push({ name: "dctfweb.fechamento" });
    },
    async listar_dctfweb_inicial() {
      this.getUsers();
      this.loadingInicial = true;
      await this.listar_dctfweb();
      this.loadingInicial = false;
    },
    async listar_dctfweb() {
      this.loading = true;
      if (this.empresas_id) {
        this.filtros.empresas_id = this.empresas_id.split(",");
      } else {
        this.filtros.empresas_id = null;
      }

      const { filtros } = this;

      let rota = "dctfweb/" + this.$route.params.atividade_competencia_id;

      await this.$store.dispatch("dctfweb/listar_dctfweb", {
        rota: rota,
        filtros: filtros,
      });
      this.loading = false;
      this.lista_dctfweb_original = structuredClone(this.dctfweb.data);
    },

    async AtualizarDadosPlanilha() {
      this.loading = true;
      await this.$store.dispatch("dctfweb/atualizar_dados_planilha", {
        atividade_competencia_id: this.$route.params.atividade_competencia_id,
      });
      this.loading = false;
      this.listar_dctfweb();
    },
    async carregarPlanilha() {
      this.loading = true;
      await this.$store.dispatch("dctfweb/carregar_dctfweb", {
        atividade_competencia_id: this.$route.params.atividade_competencia_id,
      });
      this.loading = false;
      this.listar_dctfweb();
    },
    getCamposAlterados(novoValor, valorAntigo) {
      let camposAlterados = {};

      // console.log(valorAntigo)
      const valores = ["opcoes", "status", "conferido", "user_up"];
      camposAlterados["id"] = novoValor["id"];

      for (let i = 0; i < valores.length; i++) {
        console.log(
          valores[i] +
            ": " +
            novoValor[valores[i]] +
            "!==" +
            valorAntigo[valores[i]]
        );
        if (novoValor[valores[i]] !== valorAntigo[valores[i]]) {
          camposAlterados[valores[i]] = novoValor[valores[i]];
        }
      }

      return camposAlterados;
    },
    async atualizarPlaniha() {
      const atividadesComparacao = structuredClone(this.lista_dctfweb);
      let atividades = atividadesComparacao
        .map((atividadeAtual) => {
          const atividadeOriginal = this.lista_dctfweb_original.find(
            (atividade) => atividade.id === atividadeAtual.id
          );
          let alterado = false;
          if (
            atividadeAtual.conferido !== atividadeOriginal.conferido ||
            atividadeAtual.opcoes !== atividadeOriginal.opcoes ||
            atividadeAtual.status !== atividadeOriginal.status ||
            atividadeAtual.responsavel !== atividadeOriginal.responsavel
          ) {
            alterado = true;
          }
          if (alterado) {
            return {
              id: atividadeAtual.id,
              conferido: atividadeAtual.conferido,
              opcoes: atividadeAtual.opcoes,
              status: atividadeAtual.status,
              responsavel: atividadeAtual.responsavel,
            };
          }
        })
        .filter(Boolean);
      if (atividades.length === 0) {
        this.$snack.warning("Não houve modificações na tabela");
        return;
      }

      this.loading = true;
      await this.$store
        .dispatch("dctfweb/update_geral_dctfweb", atividades)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((err) => {
          this.$snack.error("erro " + err);
        })
        .finally(() => {
          this.loading = false;
        });
      this.lista_dctfweb_original = structuredClone(this.dctfweb.data);
    },
    onPageChange(page) {
      this.current_page = page;
    },
    async exportPlanilha(nome) {
      this.loading = true;
      let data = {
        id: this.$route.params.atividade_competencia_id,
        tipo: "dctfweb",
      };
      await this.$store.dispatch("empresas/" + nome, data);
      this.loading = false;
    },
    handleClick(value) {
      // Ação ao clicar (clique duplo)
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${value}/open?token=${this.getToken}`
      );
    },
    upload(route) {
      this.$router.push({
        name: route,
        params: {
          atividade_competencia_id: this.$route.params.atividade_competencia_id,
        },
      });
    },
    getUsers() {
      usersRequest().then(({ data: { data } }) => {
        let arrayNew = [];

        for (let i = 0; i < data.length; i++) {
          if (data[i].deleted_at == null) {
            arrayNew.push({ id: data[i].id, label: data[i].nome_completo });
          }
        }

        this.lista_usuarios = arrayNew;
      });
    },
    getColStyle(field) {
      switch (field) {
        case "empresa_id":
          return "width: 80px;  position: sticky;left: 0; background-color: #fff;z-index: 1;background-color:#031127; color:white";
          break;
        case "cnpj":
          return "width: 100px;  position: sticky;left: 80px; background-color: #fff;z-index: 2;background-color:#031127; color:white";
          break;
        case "razao_social":
          return "width: 400px;";
          break;
        case "regime_tributario":
          return "width: 300px;";
          break;
        case "opcoes":
          return "width: 250px;";
          break;
        case "conferido":
          return "width: 200px;";
          break;
        case "arquivoDctfweb":
          return "width: 200px;";
          break;
        case "logs":
          return "width: 300px;";
          break;
        default:
          return "width: 200px;";
          break;
      }
    },
    calcularTamanhoTabela() {
      let totalWidth = 0;
      this.colunas.map((column) => {
        switch (column.field) {
          case "empresa_id":
            totalWidth += 80;
            break;
          case "cnpj":
            totalWidth += 100;
            break;
          case "razao_social":
            totalWidth += 400;
            break;
          case "regime_tributario":
            totalWidth += 300;
            break;
          case "opcoes":
            totalWidth += 250;
            break;
          case "logs":
            totalWidth += 250;
            break;
          case "arquivoDctfweb":
            totalWidth += 250;
            break;
          default:
            totalWidth += 200;
            break;
        }
      });
      totalWidth += 100;

      return totalWidth;
    },
    closeArquivosAtividadeModal() {
      this.arquivosAtividadeModal = false;
      this.currentArquivosAtividade = {};
    },
    async searchEmpresa(empresa) {
      this.loading = true;
      await searchEmpresasRequest(empresa).then((res) => {
        this.empresasAusentes = this.empresasAusentesEstaoSelecionada;

        const newEmpresas = res.data.data
          .filter(
            (item) =>
              !this.empresasAusentesEstaoSelecionada.some(
                (empresa) => empresa.id === item.id
              )
          )
          .map((item) => {
            return {
              id: item.id,
              nome: item.razao_social,
            };
          });

        this.empresasAusentes.push(...newEmpresas);
      });
      this.clearSearchQuery();

      this.loading = false;
    },
    async adicionarEmpresas() {
      this.loading = true;
      let form = {
        atividade_competencia_id: this.$route.params.atividade_competencia_id,
        ids: this.empresasAusentesSelecionadas,
      };
      await this.$store
        .dispatch("dctfweb/adicionar_empresas", form)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((err) => {
          this.$snack.error("erro " + err);
        })
        .finally(() => {
          this.loading = false;
        });
      this.listar_dctfweb_inicial();
    },
    validarCompetencia(atividade) {
      let contador = 0;
      let totalArquivos = 0;
      atividade.arquivo_dctfweb.forEach((arquivo) => {
        if (arquivo.data_competencia) {
          contador++;
        }
        totalArquivos++;
      });
      return this.tipo_atividade.bloqueio
        ? !(this.tipo_atividade.bloqueio && contador == totalArquivos)
        : false;
    },

    // Todo: caso for usar em outros lugares essa prioridade refactorar aqui e em guias
    async showModalPrioridadeEmpresa(linhaAtividade, acao, data = null) {
      if (acao === "form") {
        this.formPrioridade = {
          empresa_id: linhaAtividade.empresa_id,
          data: data,
          motivo: null,
          tipo: TipoDataObrigatoriedade.atividade,
        };
      }
      this.modalPrioridade.open = true;
      this.modalPrioridade.acao = acao;
      this.linhaAtividadeEmpresa = linhaAtividade;
    },

    generateOptions() {
      const month = new Date().getMonth() + 1;
      const year = new Date().getFullYear();
      const daysInMonth = new Date(year, month, 0).getDate();
      let options = [];
      for (let i = 1; i <= daysInMonth; i++) {
        options.push({ id: i, label: i });
      }
      return options;
    },
    async sendPrioridadeEmpresa() {
      this.loading = true;
      await this.$store.dispatch(
        "prioridadeEmpresa/create_prioridade_empresa",
        this.formPrioridade
      );

      const formLinhaAtividade = {
        id: this.linhaAtividadeEmpresa.id,
        data: moment().format(`YYYY-MM-${this.formPrioridade.data}`)
      };
      await this.$store.dispatch("dctfweb/update_dctfweb", formLinhaAtividade);

      this.loading = false;
      this.modalPrioridade.open = false;
      this.linhaAtividadeEmpresa = null;
    },

    atualizouPrioridade() {
      this.modalPrioridade.open = false;
      this.listar_dctfweb();
    },
   async  deletePrioridadeEmpresa(){
      const formLinhaAtividade = {
        id: this.linhaAtividadeEmpresa.id,
        data:null,
      };
      this.loading = true;
      await this.$store.dispatch("dctfweb/update_dctfweb", formLinhaAtividade);
      this.loading = false;
      this.modalPrioridade.open = false;
      this.linhaAtividadeEmpresa = null;
      this.listar_dctfweb();

    }
  },
};
</script>

<style scoped>
.table-container {
  overflow-x: auto;
  width: 100%;
}
</style>

  